import React, { useState, useEffect } from "react";
import { Collapse, Checkbox, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { SetNewEmployees } from "../../Slices/employeeslice";
import { SIDEMENU } from "../../databucket";
import { useErrorLogger } from "../../utils";
import Modal from "../../blueplanitUtils/Modal";
import { InputField, SelectInput, DatePickerField } from "../../blueplanitUtils/InputField";
import { validateInput } from "../../blueplanitUtils/validationUtils";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate";
import { setLoader } from "../../Slices/loaderSlice";
import { getOptionsByPath, useNestedDropdownHandler } from "../../utilsdata";
import { addEmployeeThunk } from "../../Slices/Thunk/employeeThunk";
import { fetchDynamicRoutes } from "../../Slices/DyanamicRoute";
import { EMPLOYEE_PROCESS_SPECIALIZATION, EMPLOYEE_BDE, EMPLOYEE_TECHNICAL_SPECIALIZATION } from "../../Dropdownmanager";
import { EMPLOYEE_DEPARTMENT, ADD_EDIT_EMPLOYEE, GENDER, USER_TYPE, BLOOD_GROUP, MARITAL_STATUS, ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_STATUS } from "../../Dropdownmanager";
const AllEmployeeAddPopup = () => {
  const dispatch = useDispatch();
  const { logError } = useErrorLogger();
  const [isUserDataValid, setIsUserDataValid] = useState(false);
  const [sidemenu, setSidemenu] = useState(SIDEMENU);

  const clientOptions = useSelector(state => state.clients.clients);
  const AllEmployees = useSelector((state) => state.employee.AllEmployees);

  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const ProcessSpecialization = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_PROCESS_SPECIALIZATION])
  const BusinessDevelopment = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_BDE])
  const TechnicalSpecialization = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_TECHNICAL_SPECIALIZATION])

  const empRoute = useSelector(state => state.Route.empRoute);
  useEffect(() => {
    dispatch(fetchDynamicRoutes());
  }, [dispatch]);
  const activeClientOptions = clientOptions
    ?.filter(clientOption => clientOption?.status === "Active" || "active")
    .map(clientOption => ({
      label: clientOption?.clientName,
      value: clientOption?.clientName,
    }));
  const initialState = {
    EmpID: "",
    firstname: "",
    lastname: "",
    dob: "",
    gender: "",
    currentAddress: "",
    mobile: "",
    department: "",
    designation: "",
    clients: "",
    reportingTo: "",
    bloodGroup: "",
    salaryCTC: "",
    permanentAddress: "",
    maritalStatus: "",
    processSplization: [],
    alternativeNumber: "",
    email: "",
    employeestatus: "Active",
    personalEmail: "",
    DateOfJoining: "",
    role: '',
    additionalRoles: [],

  };
  const Departmentoptions = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT]);
  const { selectedId, selectedValue, handleChange, reset } = useNestedDropdownHandler(Departmentoptions, "department");
  const accessOptions = [
    { label: "Web Application", value: "WEB" },
    { label: "Desktop Application", value: "DESKTOP" },
    { label: "Web + Desktop", value: "BOTH" }
  ];

  const handleModalClose = () => {
    setUserData(initialState);
    setErrores({});
    setSidemenu(SIDEMENU);
    reset();
  };

  const [userData, setUserData] = useState(initialState);
  const [errores, setErrores] = useState({});

  const handleInputChange = (e) => {

    const { name, value, } = e.target;
    let newUserData = { ...userData, [name]: value };
    if (name === "department") {
      newUserData.designation = "";
    }
    setUserData(newUserData);
    const error = validateInput(name, value);
    setErrores((prev) => ({ ...prev, [name]: error }));

  };
  useEffect(() => {
    const requiredFields = ['mobile', 'EmpID', 'email', 'firstname', 'lastname', 'dob', 'personalEmail', 'DateOfJoining', 'gender'];

    const allFieldsValid = requiredFields.every((field) => {
      return !errores[field] && Boolean(userData[field]); // Ensure field is non-empty and has no error
    });
    const isAlternativeNumberValid = !errores['alternativeNumber'];
    setIsUserDataValid(allFieldsValid && isAlternativeNumberValid);
  }, [userData, errores]);

  useEffect(() => {
    if (empRoute && Array.isArray(empRoute)) {
      const foundItem = empRoute.find(
        (item) => item?.name === userData?.role && item.department === userData?.department
      );
      if (foundItem) {
        const fields = foundItem.fields;
        setSidemenu(fields);
      } else {
        setSidemenu(SIDEMENU);
      }
    }
  }, [userData.role, userData.department, empRoute]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      'mobile', 'EmpID', 'email', 'firstname',
      'personalEmail', 'lastname', 'gender', 'dob', 'DateOfJoining'
    ];

    const newErrors = requiredFields.reduce((acc, field) => {
      const error = validateInput(field, userData[field]);
      if (error) acc[field] = error;
      return acc;
    }, {});

    // Validate alternativeNumber only if it has a value
    if (userData.alternativeNumber?.trim()) {
      const altError = validateInput('alternativeNumber', userData.alternativeNumber);
      if (altError) newErrors.alternativeNumber = altError;
    }

    setErrores(newErrors);

    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const fieldLabels = {
        mobile: 'Phone Number', EmpID: 'Employee ID', email: 'Official Email',
        firstname: 'First Name', personalEmail: 'Personal Email', lastname: 'Last Name',
        gender: 'Gender', dob: 'Date of Birth', DateOfJoining: 'Date of Joining',
        alternativeNumber: 'Alternative Number'
      };
      const errorList = Object.entries(newErrors).map(([field, err]) => `${fieldLabels[field] || field}: ${err}`);
      message.error({
        content: errorList.length === 1
          ? errorList[0]
          : `Please fix ${errorList.length} errors: ${errorList.join(', ')}`,
        duration: 5,
      });
      return;
    }

    dispatch(setLoader(true));

    try {
      const cleanedSidemenu = sidemenu.map((item) => {
        const { __typename, Subfields, ...rest } = item;
        const cleanedSubfields = Subfields?.map(({ __typename, ...subRest }) => subRest) || [];
        return { ...rest, Subfields: cleanedSubfields };
      });

      const result = await dispatch(addEmployeeThunk({
        ...userData,
        menu: cleanedSidemenu,
      }));

      const data = result?.data;

      if (data?.createEmploye?.status) {
        const newEmployee = data.createEmploye.response;
        dispatch(SetNewEmployees(newEmployee));
        message.success({
          content: data.createEmploye.message,
          duration: 5,
        });
      } else if (data?.createEmploye) {
        message.error({
          content: data.createEmploye.message || "Failed to create employee",
          duration: 5,
        });
      } else {
        message.error({
          content: "Failed to create employee. Please try again.",
          duration: 5,
        });
      }

    } catch (error) {
      await logError("AllEmployeeAddPop", "handleSubmit", error.message);
      console.error("Error occurred during handleSubmit AllEmployeeAddPop:", error);

      message.error({
        content: "Failed to create employee. Please try again.",
        duration: 5,
        className: "alert alert-danger text-center",
      });

    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleParentCheckboxChange = (index) => {
    setSidemenu((prevMenu) =>
      prevMenu.map((menu, i) =>
        i === index
          ? {
            ...menu,
            status: !menu.status,
            key: !menu.status ? menu.key : false, // Set key to false if status is false
            Subfields: menu.Subfields.map((subfield) => ({
              ...subfield,
              status: !menu.status,
              key: !menu.status ? subfield.key : false, // Update key based on status
            })),
          }
          : menu
      )
    );
  };

  const collapseItems = sidemenu?.map((menu, index) => ({
    key: index.toString(),
    label: (
      <Checkbox
        checked={menu.status}
        onChange={() => handleParentCheckboxChange(index)}
        style={{ fontFamily: "serif", fontSize: "16px" }}
      >
        {menu.name}
      </Checkbox>
    ),
    children: (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {menu.Subfields?.map((sub, subIndex) => (
          <div
            key={subIndex}
            style={{
              maxWidth: "200px",
              padding: "5px",
              display: "flex",
              alignItems: "center",
              border: "1px solid #ddd",
              borderRadius: "5px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Checkbox
              checked={sub.status}
              disabled={!menu.status}
              onChange={() => handleSubfieldCheckboxChange(index, subIndex)}
            >
              {sub.displayName}
            </Checkbox>
          </div>
        ))}
      </div>
    ),
  }));


  const handleSubfieldCheckboxChange = (parentIndex, subIndex) => {
    setSidemenu((prevMenu) =>
      prevMenu.map((menu, i) =>
        i === parentIndex
          ? (() => {
            // Toggle subfield status first
            const updatedSubfields = menu.Subfields.map((subfield, j) =>
              j === subIndex
                ? { ...subfield, status: !subfield.status, key: !subfield.status ? subfield.key : false }
                : subfield
            );

            // Check if all subfields are now false
            const allSubfieldsFalse = updatedSubfields.every(sub => !sub.status);

            return {
              ...menu,
              Subfields: updatedSubfields,
              status: allSubfieldsFalse ? false : menu.status, // If all false, uncheck main route
              key: allSubfieldsFalse ? false : menu.key, // If all false, key should also be false
            };
          })()
          : menu
      )
    );
  };
  const names = AllEmployees
    .filter(item => item.employeestatus === "Active")
    .map((item, index) => ({
      key: index,
      label: `${item.firstname} ${item.lastname}`,
      value: `${item.firstname} ${item.lastname}`,
    }));

  return (
    <Modal
      id="add_employee"
      title="Add Employee"
      handleModalClose={handleModalClose}
      handleSubmit={handleSubmit}
      isUserDataValid={false}
    >
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6 mb-2">
              <InputField
                formcontrol="form-control"
                label="Employee ID"
                type="number"
                name="EmpID"
                value={(userData?.EmpID)?.trim() || ""}
                onChange={handleInputChange}
                error={errores.EmpID}
                max="99999"
                min="0"
                required={true}
                onInput={(e) => {
                  if (e.target.value.length > 5) {
                    e.target.value = e.target.value.slice(0, 5);
                  }
                }}
              />
            </div>
            <div className="col-md-6 mb-2">
              <DatePickerField
                label="Date of Joining"
                name="DateOfJoining"
                format="DD/MM/YYYY"
                classname="form-control"
                required={true}
                formcontrol={'w-100'}
                value={userData?.DateOfJoining ? dayjs(userData.DateOfJoining) : null} // Ensure dayjs format
                onChange={(date) => {
                  const isoString = date ? date.toISOString() : null;
                  handleInputChange({
                    target: {
                      name: "DateOfJoining",
                      value: isoString, // Store in ISO format
                    },
                  })
                }}
                error={errores?.DateOfJoining}
                max={dayjs().add(1, 'year')}
                onKeyDown={handleKeyDown}
              /></div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-2">
              <InputField
                formcontrol="form-control"
                label="First Name"
                type="text"
                name="firstname"
                required={true}
                value={userData?.firstname}
                onChange={handleInputChange}
                error={errores.firstname}
              />
            </div>
            <div className="col-md-6 mb-2">
              <InputField
                formcontrol="form-control"
                label="Last Name"
                type="text"
                name="lastname"
                required={true}
                value={userData?.lastname}
                onChange={handleInputChange}
                error={errores.lastname}
              />
            </div>
            <div className="col-md-6 mb-2">
              <DatePickerField
                label="Birth Date"
                classname="form-control"
                name="dob"
                formcontrol={'w-100'}
                value={userData?.dob ? dayjs(userData.dob) : null} // Convert stored value to Day.js
                format="DD/MM/YYYY" // Ensure the correct date format
                onChange={(date, dateString) => {
                  handleInputChange({
                    target: {
                      name: "dob",
                      value: date ? date.toISOString() : null,
                    },
                  });
                }}
                error={errores?.dob}
                required={true}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="col-md-6 mb-2">
              <SelectInput
                label="Gender"
                name="gender"
                value={userData?.gender}
                onChange={(e) => {
                  handleInputChange({
                    target: {
                      name: "gender",
                      value: e,
                    }
                  })
                }}
                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, GENDER])}
                formControl={true}
                style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                error={errores.gender}
                required={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 mb-2">
          <InputField
            formcontrol="form-control"
            label="Current Address"
            type="text"
            name="currentAddress"
            value={userData?.currentAddress}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-md-12 mb-4">
          <InputField
            formcontrol="form-control"
            label="Permanent Address"
            type="text"
            name="permanentAddress"
            value={userData?.permanentAddress}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-md-6 mb-2">
          <InputField
            required={true}
            formcontrol="form-control"
            label="Phone Number"
            type="text"
            name="mobile"
            value={userData?.mobile.trim()}
            onChange={handleInputChange}
            error={errores.mobile}
          />
        </div>
        <div className="col-md-6 mb-2">
          <InputField
            formcontrol="form-control"
            label="Alternative Number"
            type="text"
            name="alternativeNumber"
            value={userData?.alternativeNumber}
            onChange={handleInputChange}
            error={errores.alternativeNumber}
          />
        </div>
        <div className="col-md-6 mb-2">
          <InputField
            formcontrol="form-control"
            label="Email"
            type="text"
            name="email"
            required={true}
            value={userData?.email.trim()}
            onChange={handleInputChange}
            error={errores.email}
          />
        </div>
        <div className="col-md-6 mb-2">
          <InputField
            required={true}
            formcontrol="form-control"
            label="Personal Email"
            type="text"
            name="personalEmail"
            value={userData?.personalEmail}
            onChange={handleInputChange}
            error={errores.personalEmail}
          />
        </div>
        <div className="col-md-6 ">
          <SelectInput
            label="Reporting To"
            name="reportingTo"
            value={userData?.reportingTo}
            onChange={(e) =>
              handleInputChange({
                target: {
                  name: "reportingTo",
                  value: e,
                }
              })
            }
            formControl={true}
            options={names}
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.department}

          />
        </div>
        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="Department"
            name="department"
            value={selectedValue}
            onChange={(value) => handleChange(value, handleInputChange)}
            options={Departmentoptions}
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.department}
          />
        </div>
        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="designation"
            name="designation"
            value={userData?.designation}
            onChange={(e) =>
              handleInputChange({
                target: {
                  name: "designation",
                  value: e,
                }
              })
            }
            options={getOptionsByPath(NestedDatabucket, [...[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT], selectedId])}
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.department}
          />
        </div>
        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="Usertype"
            name="role"
            value={userData?.role}
            onChange={(e) => {
              handleInputChange({
                target: {
                  name: "role",
                  value: e,
                }
              })
            }}
            options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, USER_TYPE])}
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.role}
          />

        </div>
        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="Status"
            name="employeestatus"
            value={userData?.employeestatus}
            onChange={(e) => {
              handleInputChange({
                target: {
                  name: "employeestatus",
                  value: e,
                }
              })
            }}
            options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_STATUS])}
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.employeestatus}
          />
          {/* <div className="col-md-6">
            <SelectInput
              formControl={true}
              label="Access"
              name="accessType"
              value={userData.accessType}
              required={true}
              onChange={(value) =>
                handleInputChange({
                  target: {
                    name: "accessType",
                    value
                  }
                })
              }
              options={accessOptions}
              placeholder="Select Access"
              error={errores.accessType}
            />
          </div> */}
        </div>
        {userData.department !== "Sales" && (
          <div className="col-md-6">
            <div className="input-block mb-3">
              <label className="col-form-label">Additional Responsibilities</label>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 4 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 14 }}>
                  <input
                    type="checkbox"
                    checked={(userData.additionalRoles || []).includes("Sales")}
                    onChange={(e) => {
                      const roles = [...(userData.additionalRoles || [])];
                      if (e.target.checked) {
                        if (!roles.includes("Sales")) roles.push("Sales");
                      } else {
                        const idx = roles.indexOf("Sales");
                        if (idx >= 0) roles.splice(idx, 1);
                      }
                      handleInputChange({ target: { name: "additionalRoles", value: roles } });
                    }}
                    style={{ width: 16, height: 16 }}
                  />
                  Handles Sales Responsibilities
                </label>
              </div>
            </div>
          </div>
        )}
        {(userData.department === "Operations" || userData.department === "Sales" || userData.department === "IT") && (
          <div className="col-md-6">
            <SelectInput
              mode="multiple" // Corrected spelling
              formControl={true}
              label={userData.department === "Sales"
                ? "Sales Specialization"
                : userData.department === "IT"
                  ? "Technical Specialization"
                  : "Process Specialization"
              }
              name="processSplization"
              value={userData?.processSplization || []} // Ensure it's always an array
              onChange={(selectedValues) =>
                handleInputChange({
                  target: {
                    name: "processSplization",
                    value: selectedValues, // Extract only values
                  },
                })
              }
              options={
                userData.department === "Operations"
                  ? ProcessSpecialization
                  : userData.department === "Sales"
                    ? BusinessDevelopment
                    : userData.department === "IT"
                      ? TechnicalSpecialization
                      : []
              }
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.employeestatus}
            />
          </div>
        )}
        {userData.department === "Operations" && (
          <div className="col-md-6">

            <SelectInput
              formControl={true}
              label="Client"
              name="clients"
              value={userData?.clients}
              onChange={(e) => {
                handleInputChange({
                  target: {
                    name: "clients",
                    value: e,
                  }
                })
              }}
              options={activeClientOptions}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.clients}
            />

          </div>

        )}



        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="Marital Status"
            options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, MARITAL_STATUS])}
            value={userData?.maritalStatus}
            onChange={(e) => {
              handleInputChange({
                target: {
                  name: "maritalStatus",
                  value: e,
                }
              })
            }}
            name="maritalStatus"
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
            error={errores.maritalStatus}
          />
        </div>
        <div className="col-md-6">
          <SelectInput
            formControl={true}
            label="Blood Group"
            options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, BLOOD_GROUP])}
            value={userData?.bloodGroup}
            onChange={(e) => {
              handleInputChange({
                target: {
                  name: "bloodGroup",
                  value: e,
                }
              })
            }}
            name="bloodGroup"
            style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
          />
        </div>
        <div className="col-md-6">
          <InputField
            formControl={true}
            label="Salary CTC"
            type="text"
            name="salaryCTC"
            value={userData?.salaryCTC || ""}
            onChange={handleInputChange}
            error={errores.salaryCTC}
          />
        </div>
      </div>
      <div
        style={{
          padding: "20px",
          background: "#fff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",

        }}
      >


        <Collapse items={collapseItems} />
      </div>

    </Modal >
  );
};


export default AllEmployeeAddPopup;

